import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '@/api/client'
import type { CreateSourceInput, RunSourceResult, Source, UpdateSourceInput } from '@/api/types'

const KEY = ['sources'] as const

export function useSources() {
  return useQuery({
    queryKey: KEY,
    queryFn: api.listSources,
    refetchInterval: 15_000,
  })
}

export function useCreateSource() {
  const qc = useQueryClient()
  return useMutation<{ id: number; slug: string }, Error, CreateSourceInput>({
    mutationFn: (input) => api.createSource(input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY })
    },
  })
}

export function useUpdateSource() {
  const qc = useQueryClient()
  return useMutation<void, Error, { id: number; input: UpdateSourceInput }>({
    mutationFn: ({ id, input }) => api.updateSource(id, input),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY })
    },
  })
}

export function useRunSource() {
  const qc = useQueryClient()
  return useMutation<RunSourceResult, Error, number>({
    mutationFn: (id) => api.runSource(id),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: KEY })
      void qc.invalidateQueries({ queryKey: ['job-runs'] })
    },
  })
}

export type { Source }
